// extracted by mini-css-extract-plugin
module.exports = {"entityLogo":"EntityLogo_entityLogo__29IUu","entityLogoImage":"EntityLogo_entityLogoImage__4X0wF","entityLogoWithHover":"EntityLogo_entityLogoWithHover__XynBQ"};